// import NProgress from 'nprogress';
import { Message } from 'element-ui';
// import 'nprogress/nprogress.css';
import router from './router'
import store from './store'
import types from './store/types';
import { removeToken, getToken } from '@/utils/auth';
import { fetchSysConfig } from '@/api/sysConfig';
import { fetchBusinessConfig } from '@/api/businessConfig';
import vm from './main';

// NProgress.configure({ ease: 'linear', speed: 1000, showSpinner: false, minimum: 0.1 })
const regex = /^\/knowledge\-manage\/\S+\/detail$/;

router.beforeEach((to, from, next) => {
  // NProgress.start();
  const isCustomer = store.state.base.userInfo.identity === 'consumer';
  if (to.path === '/variable-home') {
    if (isCustomer) {
      next('/customerHome');
    } else {
      next('/home')
    }
  } if(to.name === 'knowledgeShare') {
    next();
  } else if(getToken()) {
    if(to.path === '/login') {
      next('/');
    } else if (!store.state.base.roleIds.length) {
      if(!!store.state.base.userInfo.id) {
        Message.error('此账号权限不足');
        store.commit(types.CLEAR_LOGININFO);
        removeToken();
        next('/login');
      } else {
        store.dispatch('loginByToken')
          .then(accessedRouters => {
            router.resetRouter(accessedRouters);
            next({ ...to });
          })
          .catch(() => {
            store.commit(types.CLEAR_LOGININFO);
            removeToken();
            next('/login');
          })
      }
    } else {
      next();
    }
  } else if(to.path === '/login') {
    next();
  } else {
    store.commit(types.CLEAR_LOGININFO);
    removeToken();
    next('/login');
  }
});

router.afterEach((to, from) => {
  store.commit(`nav/${types.SET_BREADCRUMB}`, to.meta.breadcrumb);
  if (!from.name) {
    fetchSysConfig()
      .then(res => {
        store.commit(`setting/${types.SET_SYS_CONFIG}`, res.data.data || {});
        document.title = (res.data.data || {}).name || '信服魔方';
        vm.$bus.emit('refresh-sys-config');
      });
    fetchBusinessConfig()
      .then(res => {
        store.commit(`setting/${types.SET_BUSINESS_CONFIG}`, res.data.data || {});
      })
  }
  // NProgress.done()
});


// WEBPACK FOOTER //
// ./src/permission.js